"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[223],{

/***/ 844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/Button/Button.tsx



const Button = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { primary , secondary , className , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (0,clsx_m/* default */.Z)("button", {
            "button--primary": primary,
            "button--secondary": secondary
        }, className),
        ref: ref,
        ...rest
    });
});
Button.displayName = "Button";
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/Button/index.tsx

/* harmony default export */ var components_Button = (Button_Button);


/***/ }),

/***/ 3432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Form_FormFields; },
  "X": function() { return /* binding */ fields; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-label/dist/index.module.js
var index_module = __webpack_require__(2602);
;// CONCATENATED MODULE: ./src/components/Form/Label/Label.tsx



function Label(props) {
    const { text , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.f, {
        className: "label",
        asChild: true,
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
            children: text
        })
    });
}
/* harmony default export */ var Label_Label = (Label);

;// CONCATENATED MODULE: ./src/components/Form/Label/index.tsx

/* harmony default export */ var Form_Label = (Label_Label);

;// CONCATENATED MODULE: ./src/components/Form/Input/Input.tsx



const Input = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    const { label , ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "input",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Label, {
                htmlFor: rest.id,
                text: "".concat(label).concat(!rest.required ? " (optional)" : "")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: ref,
                ...rest,
                name: rest.id,
                className: "input__element"
            })
        ]
    });
});
Input.displayName = "Input";
/* harmony default export */ var Input_Input = (Input);

;// CONCATENATED MODULE: ./src/components/Form/Input/index.tsx

/* harmony default export */ var Form_Input = (Input_Input);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/EmailField/EmailField.tsx



function EmailField(props) {
    const { label , clean_name: cleanName , field_type: fieldType , help_text: helpText , required  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: fieldType,
        id: cleanName,
        placeholder: helpText,
        required: required
    });
}
/* harmony default export */ var EmailField_EmailField = (EmailField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/EmailField/index.tsx

/* harmony default export */ var FormFields_EmailField = (EmailField_EmailField);

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-visually-hidden/dist/index.module.js
var dist_index_module = __webpack_require__(9349);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(6594);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-icons/dist/react-icons.esm.js
var react_icons_esm = __webpack_require__(2469);
;// CONCATENATED MODULE: ./src/components/Form/FormFields/SelectField/SelectField.tsx






function SelectField(props) {
    const { choices , clean_name: cleanName , label , default_value: defaultValue  } = props;
    // return (
    //   <Select
    //     items={choices
    //       .split(',')
    //       .map(choice => ({ text: choice, value: choice }))}
    //     defaultValue={default_value}
    //     ariaLabel={label}
    //     label={label}
    //     id={clean_name}
    //     fluid
    //   />
    // );
    const items = choices.split(",");
    const { isOpen , selectedItem , getToggleButtonProps , getLabelProps , getMenuProps , highlightedIndex , getItemProps  } = (0,downshift_esm/* useSelect */.L7)({
        items,
        defaultSelectedItem: defaultValue || (items === null || items === void 0 ? void 0 : items[0])
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "downshift-select",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Label, {
                ...getLabelProps(),
                text: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "downshift-select__button",
                type: "button",
                ...getToggleButtonProps(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: selectedItem !== null && selectedItem !== void 0 ? selectedItem : "keine Auswahl"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "downshift-select__chevron",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* ChevronDownIcon */.v4q, {
                            width: 48,
                            height: 48
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                ...getMenuProps(),
                className: "downshift-select__list",
                children: isOpen && items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "downshift-select__list-item",
                        style: highlightedIndex === index ? {
                            backgroundColor: "#bde4ff"
                        } : {},
                        ...getItemProps({
                            item,
                            index
                        }),
                        children: item
                    }, "".concat(item).concat(index)))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.f, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    name: cleanName,
                    defaultValue: selectedItem !== null && selectedItem !== void 0 ? selectedItem : "",
                    type: "hidden"
                })
            })
        ]
    });
}
/* harmony default export */ var SelectField_SelectField = (SelectField); // return (
 //   <Select
 //     items={choices
 //       .split(',')
 //       .map(choice => ({ text: choice, value: choice }))}
 //     defaultValue={default_value}
 //     ariaLabel={label}
 //     label={label}
 //     id={clean_name}
 //     fluid
 //   />
 // );

;// CONCATENATED MODULE: ./src/components/Form/FormFields/SelectField/index.tsx

/* harmony default export */ var FormFields_SelectField = (SelectField_SelectField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/FormFields.tsx



const extractFieldsets = (formFields)=>{
    const groupedFields = formFields.reduce((prev, curr)=>{
        var _prev_curr_fieldset, _prev_curr_fieldset1;
        if (!curr.fieldset) {
            return {
                ...prev,
                [curr.clean_name]: curr
            };
        }
        var _prev_curr_fieldset_sort_order, _prev_curr_fieldset_fields;
        return {
            ...prev,
            [curr.fieldset]: {
                field_type: "fieldset",
                legend: curr.fieldset,
                sort_order: Math.min((_prev_curr_fieldset_sort_order = (_prev_curr_fieldset = prev[curr.fieldset]) === null || _prev_curr_fieldset === void 0 ? void 0 : _prev_curr_fieldset.sort_order) !== null && _prev_curr_fieldset_sort_order !== void 0 ? _prev_curr_fieldset_sort_order : Infinity, curr.sort_order),
                fields: [
                    ...(_prev_curr_fieldset_fields = (_prev_curr_fieldset1 = prev[curr.fieldset]) === null || _prev_curr_fieldset1 === void 0 ? void 0 : _prev_curr_fieldset1.fields) !== null && _prev_curr_fieldset_fields !== void 0 ? _prev_curr_fieldset_fields : [],
                    curr
                ]
            }
        };
    }, {});
    return Object.values(groupedFields);
};
function FormFields(props) {
    const { formFields  } = props;
    const formFieldsByFieldsets = extractFieldsets(formFields.sort((a, b)=>a.sort_order - b.sort_order));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            formFieldsByFieldsets.map((field, index)=>{
                const Component = fields[field.field_type];
                if (!Component) {
                    var _field_id;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "Unknown form field ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: field.field_type
                            })
                        ]
                    }, (_field_id = field.id) !== null && _field_id !== void 0 ? _field_id : "fieldset-".concat(index));
                }
                var _field_id1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                    ...field
                }, (_field_id1 = field.id) !== null && _field_id1 !== void 0 ? _field_id1 : "fieldset-".concat(index));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    overflow: "hidden",
                    width: 0,
                    height: 0
                },
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "decoy-comments",
                        children: "Leave this blank if you're a human"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                        rows: 1,
                        name: "decoy-comments",
                        id: "decoy-comments"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var FormFields_FormFields = (FormFields);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/DateField/DateField.tsx



function DateField(props) {
    const { label , clean_name: cleanName , help_text: helpText , default_value: defaultValue , required  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: "date",
        id: cleanName,
        placeholder: helpText,
        defaultValue: defaultValue || new Date().toISOString().split("T")[0],
        required: required
    });
}
/* harmony default export */ var DateField_DateField = (DateField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/DateField/index.tsx

/* harmony default export */ var FormFields_DateField = (DateField_DateField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/DateTimeField/DateTimeField.tsx



function DateTimeField(props) {
    const { label , clean_name: cleanName , help_text: helpText  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: "datetime-local",
        id: cleanName,
        placeholder: helpText
    });
}
/* harmony default export */ var DateTimeField_DateTimeField = (DateTimeField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/DateTimeField/index.tsx

/* harmony default export */ var FormFields_DateTimeField = (DateTimeField_DateTimeField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/HiddenField/HiddenField.tsx



function HiddenField(props) {
    const { label , clean_name: cleanName , help_text: helpText  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: "hidden",
        id: cleanName,
        placeholder: helpText
    });
}
/* harmony default export */ var HiddenField_HiddenField = (HiddenField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/HiddenField/index.tsx

/* harmony default export */ var FormFields_HiddenField = (HiddenField_HiddenField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/SingleLineField/SingleLineField.tsx



function SingleLineField(props) {
    const { label , clean_name: cleanName , help_text: helpText , required  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: "text",
        id: cleanName,
        placeholder: helpText,
        required: required
    });
}
/* harmony default export */ var SingleLineField_SingleLineField = (SingleLineField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/SingleLineField/index.tsx

/* harmony default export */ var FormFields_SingleLineField = (SingleLineField_SingleLineField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/NumberField/NumberField.tsx



function NumberField(props) {
    const { label , clean_name: cleanName , help_text: helpText , required , default_value: defaultValue  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: "number",
        id: cleanName,
        placeholder: helpText,
        min: 0,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : 1,
        required: required
    });
}
/* harmony default export */ var NumberField_NumberField = (NumberField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/NumberField/index.tsx

/* harmony default export */ var FormFields_NumberField = (NumberField_NumberField);

// EXTERNAL MODULE: ./src/components/RawHtml/index.tsx + 2 modules
var RawHtml = __webpack_require__(580);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-checkbox/dist/index.module.js
var react_checkbox_dist_index_module = __webpack_require__(6093);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
;// CONCATENATED MODULE: ./src/components/Form/Checkbox/Checkbox.tsx





function Checkbox(props) {
    const { id , label , name , value , disabled , required , baseline , smallLabel  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("checkbox", {
            "checkbox--baseline": baseline
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_checkbox_dist_index_module/* Root */.fC, {
                className: "checkbox__root",
                id: id,
                name: name !== null && name !== void 0 ? name : id,
                value: value,
                disabled: disabled,
                required: required,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_checkbox_dist_index_module/* Indicator */.z$, {
                    className: "checkbox__indicator",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icons_esm/* CheckIcon */.nQG, {
                        width: 24,
                        height: 24
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (0,clsx_m/* default */.Z)("checkbox__label", {
                    "checkobx__label--small": smallLabel
                }),
                htmlFor: id,
                children: typeof label === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RawHtml/* default */.Z, {
                    html: label
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: label
                })
            })
        ]
    });
}
/* harmony default export */ var Checkbox_Checkbox = (Checkbox);

;// CONCATENATED MODULE: ./src/components/Form/Checkbox/index.tsx

/* harmony default export */ var Form_Checkbox = (Checkbox_Checkbox);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/CheckBoxField/CheckBoxField.tsx



function CheckBoxField(props) {
    const { label , clean_name: cleanName , required  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Checkbox, {
        id: cleanName,
        value: "checked",
        label: label,
        required: required
    });
}
/* harmony default export */ var CheckBoxField_CheckBoxField = (CheckBoxField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/CheckBoxField/index.tsx

/* harmony default export */ var FormFields_CheckBoxField = (CheckBoxField_CheckBoxField);

;// CONCATENATED MODULE: ./src/components/Form/Textarea/Textarea.tsx



function Textarea(props) {
    const { label , id , name , required , placeholder , default_value  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "textarea",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Label, {
                text: "".concat(label).concat(required ? "" : " (optional)"),
                htmlFor: id
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                id: id,
                name: name !== null && name !== void 0 ? name : id,
                required: required,
                placeholder: placeholder,
                children: default_value
            })
        ]
    });
}
/* harmony default export */ var Textarea_Textarea = (Textarea);

;// CONCATENATED MODULE: ./src/components/Form/Textarea/index.tsx

/* harmony default export */ var Form_Textarea = (Textarea_Textarea);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/MultiLineField/MultiLineField.tsx



function MultiLineField(props) {
    const { label , clean_name: cleanName , help_text: helpText , required , default_value: defaultValue  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Textarea, {
        label: label,
        id: cleanName,
        placeholder: helpText,
        required: required,
        default_value: defaultValue
    });
}
/* harmony default export */ var MultiLineField_MultiLineField = (MultiLineField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/MultiLineField/index.tsx

/* harmony default export */ var FormFields_MultiLineField = (MultiLineField_MultiLineField);

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-radio-group/dist/index.module.js + 2 modules
var react_radio_group_dist_index_module = __webpack_require__(2120);
;// CONCATENATED MODULE: ./src/components/Form/Fieldset/Fieldset.tsx



function Fieldset(props) {
    const { children , legend , className , asLabel  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        className: (0,clsx_m/* default */.Z)("fieldset", className, {
            "fieldset--as-label": asLabel
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                className: "fieldset__legend",
                children: legend
            }),
            children
        ]
    });
}
/* harmony default export */ var Fieldset_Fieldset = (Fieldset);

;// CONCATENATED MODULE: ./src/components/Form/Fieldset/index.tsx

/* harmony default export */ var Form_Fieldset = (Fieldset_Fieldset);

;// CONCATENATED MODULE: ./src/components/Form/RadioGroup/RadioGroup.tsx






function RadioGroup(props) {
    const { id , items , label , row , required  } = props;
    var _item_value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Fieldset, {
        className: (0,clsx_m/* default */.Z)("radio-group", {
            "radio-group--row": row
        }),
        legend: label,
        asLabel: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_radio_group_dist_index_module/* Root */.fC, {
            className: "radio-group__root",
            name: id,
            required: required,
            children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "radio-group__item-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_radio_group_dist_index_module/* Item */.ck, {
                            className: "radio-group__item",
                            value: (_item_value = item.value) !== null && _item_value !== void 0 ? _item_value : item.label,
                            id: "".concat(id, "-").concat(index),
                            required: required,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_radio_group_dist_index_module/* Indicator */.z$, {
                                className: "radio-group__indicator"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Root */.f, {
                            className: "radio-group__label",
                            htmlFor: "".concat(id, "-").concat(index),
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: item.label
                            })
                        })
                    ]
                }, "".concat(id, "-").concat(index)))
        })
    });
}
/* harmony default export */ var RadioGroup_RadioGroup = (RadioGroup);

;// CONCATENATED MODULE: ./src/components/Form/RadioGroup/index.tsx

/* harmony default export */ var Form_RadioGroup = (RadioGroup_RadioGroup);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/RadioField/RadioField.tsx



function RadioField(props) {
    const { label , clean_name: cleanName , choices , required  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_RadioGroup, {
        required: required,
        id: cleanName,
        label: label,
        items: choices.split(",").map((choice)=>({
                label: choice
            }))
    });
}
/* harmony default export */ var RadioField_RadioField = (RadioField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/RadioField/index.tsx

/* harmony default export */ var FormFields_RadioField = (RadioField_RadioField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/CheckBoxesField/CheckBoxesField.tsx




function CheckBoxesField(props) {
    const { label , choices , clean_name: cleanName  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Fieldset, {
        legend: label,
        children: choices.split(",").map((choice)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Checkbox, {
                id: choice,
                name: cleanName,
                label: choice,
                value: choice
            }, choice))
    });
}
/* harmony default export */ var CheckBoxesField_CheckBoxesField = (CheckBoxesField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/CheckBoxesField/index.tsx

/* harmony default export */ var FormFields_CheckBoxesField = (CheckBoxesField_CheckBoxesField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/TimeField/TimeField.tsx



function TimeField(props) {
    const { label , clean_name: cleanName , help_text: helpText , default_value: defaultValue , required  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Input, {
        label: label,
        type: "time",
        id: cleanName,
        placeholder: helpText,
        defaultValue: defaultValue || "10:00",
        required: required
    });
}
/* harmony default export */ var TimeField_TimeField = (TimeField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/TimeField/index.tsx

/* harmony default export */ var FormFields_TimeField = (TimeField_TimeField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/FieldsetField/FieldsetField.tsx





function FieldsetField(props) {
    const { legend , fields: formFields  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_Fieldset, {
        legend: legend,
        children: formFields.sort((a, b)=>a.sort_order - b.sort_order).map((field)=>{
            const Component = fields[field.field_type];
            if (!Component) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    children: [
                        "Unknown form field ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: field.field_type
                        })
                    ]
                }, field.id);
            }
            return /*#__PURE__*/ (0,react.createElement)(Component, {
                ...field,
                key: field.id
            });
        })
    });
}
/* harmony default export */ var FieldsetField_FieldsetField = (FieldsetField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/FieldsetField/index.tsx

/* harmony default export */ var FormFields_FieldsetField = (FieldsetField_FieldsetField);

;// CONCATENATED MODULE: ./src/components/Form/FormFields/index.tsx















const fields = {
    checkbox: FormFields_CheckBoxField,
    checkboxes: FormFields_CheckBoxesField,
    date: FormFields_DateField,
    dropdown: FormFields_SelectField,
    datetime: FormFields_DateTimeField,
    email: FormFields_EmailField,
    hidden: FormFields_HiddenField,
    multiline: FormFields_MultiLineField,
    multiselect: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "multiselect not implemented"
        }),
    number: FormFields_NumberField,
    radio: FormFields_RadioField,
    singleline: FormFields_SingleLineField,
    time: FormFields_TimeField,
    fieldset: FormFields_FieldsetField
};

/* harmony default export */ var Form_FormFields = (FormFields_FormFields);


/***/ }),

/***/ 1223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-popover/dist/index.module.js + 32 modules
var index_module = __webpack_require__(3652);
// EXTERNAL MODULE: ./src/components/Form/FormFields/index.tsx + 39 modules
var FormFields = __webpack_require__(3432);
// EXTERNAL MODULE: ./src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(844);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/ContactPopup/ContactPopup.tsx






const formFields = [
    {
        id: 5,
        sort_order: 0,
        clean_name: "vor_und_nachname",
        label: "Vor- und Nachname",
        field_type: "singleline",
        required: true,
        choices: "",
        default_value: "",
        help_text: "",
        page_id: 27,
        fieldset: "",
        legend: "",
        fields: []
    },
    {
        id: 6,
        sort_order: 1,
        clean_name: "telefonnummer",
        label: "Telefonnummer",
        field_type: "singleline",
        required: true,
        choices: "",
        default_value: "",
        help_text: "",
        page_id: 27,
        fieldset: "",
        legend: "",
        fields: []
    },
    {
        id: 35,
        sort_order: 2,
        clean_name: "ich_akzeptiere_die_datenschutzbestimmungen",
        // eslint-disable-next-line no-useless-escape, prettier/prettier
        label: 'Ich akzeptiere die <a href="/datenschutz">Datenschutzbestimmungen.</a>',
        field_type: "checkbox",
        required: true,
        choices: "",
        default_value: "",
        help_text: "",
        page_id: 27,
        fieldset: "",
        legend: "",
        fields: []
    }
];
function ContactPopup() {
    const [status, setStatus] = (0,react.useState)("idle");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "contactpopup",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                    asChild: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "IconButton",
                        "aria-label": "Update dimensions",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            "aria-describedby": "desc",
                            "aria-labelledby": "title",
                            viewBox: "0 0 64 64",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    fill: "none",
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "3",
                                    d: "M15 10h34M15 48h34",
                                    "data-name": "layer2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                    width: "34",
                                    height: "60",
                                    x: "15",
                                    y: "2",
                                    fill: "none",
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "3",
                                    "data-name": "layer1",
                                    rx: "4",
                                    ry: "4"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                    cx: "32",
                                    cy: "55",
                                    r: "2",
                                    fill: "none",
                                    stroke: "#fff",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: "3",
                                    "data-name": "layer1"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Portal */.h_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Content */.VY, {
                        className: "PopoverContent",
                        sideOffset: 5,
                        collisionPadding: {
                            left: 20,
                            right: 20,
                            top: 350
                        },
                        alignOffset: 33,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                id: "formular",
                                method: "POST",
                                className: "form callback-form",
                                onSubmit: async (event)=>{
                                    event.preventDefault();
                                    const formData = new FormData(event.currentTarget);
                                    const data = Object.fromEntries(formData);
                                    formFields.forEach((field)=>{
                                        if (field.field_type !== "checkboxes") return;
                                        data[field.clean_name] = formData.getAll(field.clean_name);
                                    });
                                    try {
                                        setStatus("loading");
                                        const res = await fetch("".concat("https://busche-zelte.de/api", "/v2/forms/"), {
                                            method: "POST",
                                            headers: {
                                                Accept: "application/json",
                                                "Content-Type": "application/json"
                                            },
                                            body: JSON.stringify({
                                                page: 27,
                                                form_data: data
                                            })
                                        });
                                        if (res.ok) {
                                            setStatus("success");
                                        } else {
                                            setStatus("error");
                                        }
                                    } catch (error) {
                                        setStatus("error");
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormFields/* default */.Z, {
                                        formFields: formFields
                                    }),
                                    status === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "message message--success",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Vielen Dank f\xfcr Ihre Anfrage. Wir werden uns schnellstm\xf6glich mit Ihnen in Verbindung setzen."
                                        })
                                    }) : null,
                                    status === "error" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "message message--error",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Leider ist etwas schief gegangen... Bitte versuchen Sie es sp\xe4ter erneut oder senden Sie Ihre Anfrage direkt an die E-Mail-Adresse",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "mailto:info@busche-zelte.de",
                                                    children: "info@busche-zelte.de"
                                                }),
                                                "."
                                            ]
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        primary: true,
                                        type: "submit",
                                        disabled: status === "loading" || status === "success",
                                        className: "form__submit",
                                        children: "R\xfcckruf anfordern"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "callbackText",
                                        children: [
                                            "Wir melden uns innerhalb von 24 Stunden des n\xe4chsten Werktags oder nutzen Sie unser allgemeines ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "./kontakt",
                                                children: "Kontaktformular"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Close */.x8, {
                                className: "PopoverClose",
                                "aria-label": "Close",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "fill-rule": "evenodd",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-miterlimit": "10",
                                    "clip-rule": "evenodd",
                                    viewBox: "0 0 26 25",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "none",
                                            d: "M0 0h25v25H0z"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fill: "none",
                                            stroke: "#202020",
                                            "stroke-width": "2",
                                            d: "m23.48 1.47-22 22m22 0-22-22"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Arrow */.Eh, {
                                className: "PopoverArrow"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var ContactPopup_ContactPopup = (ContactPopup);

;// CONCATENATED MODULE: ./src/components/ContactPopup/index.tsx

/* harmony default export */ var components_ContactPopup = (ContactPopup_ContactPopup);

// EXTERNAL MODULE: ./src/components/RawHtml/index.tsx + 2 modules
var RawHtml = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/components/Hero/Hero.tsx




function Hero(props) {
    const { title , subtitle , showContactSticky  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        role: "banner",
        className: "hero",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    className: "hero__title",
                    children: title
                }),
                subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RawHtml/* default */.Z, {
                    className: "hero__subtitle",
                    html: subtitle
                }) : null,
                showContactSticky ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ContactPopup, {}) : null
            ]
        })
    });
}
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/Hero/index.tsx

/* harmony default export */ var components_Hero = (Hero_Hero);


/***/ })

}]);